import React from 'react';
import {hydrateRoot} from 'react-dom/client';

import FavoriteButton from "@/components/favorites/FavoriteButton.jsx";

export default function HandleFavoriteButtons() {
    const collection = document.getElementsByClassName("btn-favourite");

    for (let i = 0; i < collection.length; i++) {
        if (!collection[i] || collection[i]?.hasAttribute('processed')) {
            continue;
        }

        const attributes = Object.fromEntries(
            Array.from(collection[i].attributes).map(
                ({name, value}) => ([name, value])
            )
        )

        // Rename 'class' attribute to 'className'
        if (attributes.class) {
            attributes.className = attributes.class;
            delete attributes.class;
        }

        for (const attribute in attributes) {
            if (attribute === 'className') {
                continue;
            }
            collection[i].removeAttribute(attribute)
        }

        hydrateRoot(
            collection[i],
            <FavoriteButton {...attributes}/>
        );

        collection[i].setAttribute('processed', true)
    }
}
